import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "h2",
  "use": "h2-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"h2\"><path d=\"M6.25 1.5h1v3.75h-4.5V1.5h1V0H.25v1.5h1v9h-1V12h3.5v-1.5h-1V6.75h4.5v3.75h-1V12h3.5v-1.5h-1v-9h1V0h-3.5zm5.9 9.06 1.41-1.41c.28-.28.44-.66.44-1.06V7.5c0-.83-.67-1.5-1.5-1.5S11 6.67 11 7.5V8h1v-.5c0-.28.22-.5.5-.5s.5.22.5.5v.59c0 .13-.05.26-.15.35l-1.41 1.41c-.28.28-.44.66-.44 1.06V12h3v-1h-2v-.09c0-.13.05-.26.15-.35\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol